import React from "react";
import { useDispatch } from "react-redux";
import { configure_getting_started_progress, configure_progress } from "../../../actions/globalAction";
import "./content.scss";
import { Link } from "react-router-dom";
import { Dimmer, Loader } from "semantic-ui-react";
import Icon from "semantic-ui-react/dist/es/elements/Icon";

const HelpAndSupport = () => {
    const dispatch = useDispatch();
    const configureProgress = () => {
        let obj = {
            // total_sections: 33,
            progress_config: {
                help_and_support: 1,
            },
        };
        dispatch(configure_getting_started_progress(obj));
    };
    return (
        <>
            <div className="gs_content">
                <div className="left_content">
                    <div className="gs_header">
                        <Icon name="question circle outline" size="large" className="icon_content" color="#268af6" width="20px" height="20px" />
                        <span className="content_title">Help And Support</span>
                    </div>
                    <div className="text_content">
                        <p>{`If you are facing any query or are stuck anywhere, please feel free to reach out to us.`}</p>
                        <p>
                            You can also fill the form on this page with your query. This will create a support ticket and our client support team will respond
                            as soon as possible.
                        </p>
                        <p>
                            You can also use the chat option at the bottom right of this page to chat with a live agent or send us a message if no live agents
                            are available.
                        </p>
                        {/* <p>{`Some of the reports and other functionality use your time zone to work properly.  You can control your time zone from here.`}</p> */}
                    </div>
                    <Link to="/support">
                        <button className="gs_link" onClick={() => configureProgress()}>
                            Explore
                        </button>
                    </Link>
                </div>
                <div className="right_content">
                    <div id="gs_loader">
                        <Dimmer inverted active>
                            <Loader size="big skiptranslate">Loading</Loader>
                        </Dimmer>
                    </div>
                    <iframe
                        width="320px"
                        height="200px"
                        src="https://www.youtube.com/embed/uQyAqq77X7o"
                        title=""
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; gyroscope; picture-in-picture"
                        allowFullScreen
                        onLoad={() => (document.getElementById("gs_loader").style.display = "none")}
                        className="content_video"></iframe>
                    {/* <img className="content-img" src={profileImg} width="350px" height="200px" /> */}
                </div>
            </div>
        </>
    );
};

export default HelpAndSupport;
